import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import {
	CancellationStatusesListReservation,
	RejectedStatusesListReservation,
	Status,
} from 'src/app/common/enums/Status';
import { FiltersComponent } from 'src/app/common/filters.component';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-bag-payment-list-table-filters',
	templateUrl: './bag-payment-list-table-filters.component.html',
	styleUrls: ['./bag-payment-list-table-filters.component.scss'],
	providers: [DatePipe],
})
export class BagPaymentListTableFiltersComponent extends FiltersComponent implements AfterViewInit {
	@Input() organizations: Array<any>;
	@Input() agencies: Array<any>;
	@Input() status: Array<any>;
	@Input() paymentKinds: Array<any>;
	@Input() currency: Array<any>;
	@Input() bankAccounts: Array<any>;
	@Input() reservationStatus: Array<Status>;

	constructor(
		protected api: Data2Service,
		protected route: ActivatedRoute,
		protected router: Router,
		protected date: DateService,
		protected loader: LoaderService,
		protected datePipe: DatePipe,
	) {
		super(api, route, router);
	}

	parseFilters = {
		amount__gte: null,
		amount__lt: null,
		payment__gte: null,
		payment__lte: null,
		posting__gte: null,
		posting__lte: null,
		reservation_status: [],
		reservation_time__gte: null,
		confirmation_time__gte: null,
	};

	filters = {
		limit: '999999',
		organization_id: [],
		reservation_seller: [],
		status__in: [],
		kind__in: [],
		reservation_status: [],
		table_id__in: null,
		table_name__in: null,
		invoice_number__icontains: null,
		amount__gte: null,
		amount__lt: null,
		payment__gte: null,
		payment__lte: null,
		posting__gte: null,
		posting__lte: null,
		currency__in: [],
		bank_account_incoming__icontains: null,
		bank_account_posting__in: null,
	};

	protected filtersDefinition = {
		kind__in: {
			type: 'string',
			isArray: true,
		},
		reservation_status: {
			type: 'string',
			isArray: true,
		},
		reservation_seller: {
			type: 'string',
			isArray: true,
		},
		payment__lte: {
			type: 'string',
			isArray: false,
		},
		currency__in: {
			type: 'string',
			isArray: false,
		},
		status__in: {
			type: 'string',
			isArray: true,
		},
	};

	dateConvert: Array<string> = ['payment__gte', 'payment__lte', 'posting__gte', 'posting__lte'];

	ngAfterViewInit() {
		this.checkQueryParamsAndReturnSevenDaysBeforeDate().subscribe(async (date) => {
			if (!this.parseFilters.payment__gte) {
				this.parseFilters.payment__gte = this.datePipe.transform(date, 'YYYY-MM-dd');
				await this.filtersSave();
				this.filtersLoad();
			}
		});
	}

	protected convertSaveFilters(): void {
		Object.keys(this.filters).forEach((key) => {
			if (this.filters[key] === '' && !this.filters[key]) {
				this.filters[key] = null;
			}
			if (!Array.isArray(this.filters[key]) && this.parseFilters[key] && !this.dateConvert.includes(key)) {
				this.filters[key] = (this.parseFilters[key] * 100).toFixed(0);
			}
			if (this.dateConvert.includes(key) && this.parseFilters[key]) {
				this.filters[key] = this.datePipe.transform(this.parseFilters[key], 'yyyy-MM-dd');
			}
		});
		Object.keys(this.parseFilters).forEach((key) => {
			if (!this.parseFilters[key]) this.filters[key] = null;
		});
		this.checkStatusFilter();
	}

	checkStatusFilter(): void {
		this.filters.reservation_status = [];
		this.parseFilters.reservation_status?.forEach((obj) => {
			switch (obj) {
				case Status.CANCELED:
					this.filters.reservation_status.push(...CancellationStatusesListReservation);
					break;
				case Status.REJECTED:
					this.filters.reservation_status.push(...RejectedStatusesListReservation);
					break;
				case Status.OPTION:
					this.filters.reservation_status.push(Status.OPTION);
					break;
				case Status.CONFIRMED:
					this.filters.reservation_status.push(Status.CONFIRMED);
					break;
				default:
					this.filters.reservation_status = [];
					break;
			}
		});
		this.filters2url(this.filters);
	}

	filtersSave(): Promise<void> {
		this.convertSaveFilters();
		this.filtersClose();
		return new Promise((resolve, reject) => {
			this.api.put('/userFilters/' + this.userFilters, this.filters, (result, error) => {
				if (error) reject();
				else resolve();
			});
		});
	}

	protected filters2url(filters): void {
		if (!filters || filters instanceof Array) {
			this.selected.emit({});
			return;
		}
		filters.on = 1; // hack when no filters selected
		this.router.navigate(['.'], {
			relativeTo: this.route,
			queryParams: filters,
			preserveFragment: true,
		});
	}

	filtersClear() {
		for (const key in this.filters) {
			if (Array.isArray(this.filters[key])) {
				this.filters[key] = [];
				continue;
			}
			this.filters[key] = null;
		}
		for (const key in this.parseFilters) {
			if (Array.isArray(this.parseFilters[key])) {
				this.parseFilters[key] = [];
				continue;
			}
			this.parseFilters[key] = null;
		}
	}

	protected filtersAfterLoad() {
		this.parseFilters.payment__gte = this.filters.payment__gte;
		this.parseFilters.payment__lte = this.filters.payment__lte;
		this.parseFilters.posting__gte = this.filters.posting__gte;
		this.parseFilters.posting__lte = this.filters.posting__lte;

		this.parseFilters.amount__gte = this.filters.amount__gte ? (this.filters.amount__gte * 0.01).toFixed(2) : null;
		this.parseFilters.amount__lt = this.filters.amount__lt ? (this.filters.amount__lt * 0.01).toFixed(2) : null;
		this.filters.reservation_status?.forEach((obj) => {
			switch (obj) {
				case Status.CANCELED:
					this.parseFilters.reservation_status.push(Status.CANCELED);
					break;
				case Status.REJECTED_EXPIRATION:
					this.parseFilters.reservation_status.push(Status.REJECTED);
					break;
				case Status.OPTION:
					this.parseFilters.reservation_status.push(Status.OPTION);
					break;
				case Status.CONFIRMED:
					this.parseFilters.reservation_status.push(Status.CONFIRMED);
					break;
			}
		});
	}
}
